let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cDj36")).then(() => parcelRequire('21Xtm'));